// 综合管理
export default [
    {
      path: '/dataView',
      name: 'dataView',
      meta: {
        requireAuth: true,
        keepAlive: true
      },
      component: (resolve) => {
        require(['@/views/dataView.vue'], resolve)
      }
    },
    {
      path: '/mairuiCoin',
      name: 'mairuiCoin',
      meta: {
        requireAuth: true,
        keepAlive: true
      },
      component: (resolve) => {
        require(['@/views/mairuiCoin.vue'], resolve)
      }
    }
  ]
  


// WEBPACK FOOTER //
// ./src/router/dataView.js